import React from "react";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import Header from "./header";
import { useLocation } from "react-router-dom";


const AdminLayout = (props) => {
    const location = useLocation()
    
    return(
        <div className={classes.layout_container}>
           {!(location.pathname.startsWith('/admin/final-report/')) &&  <Header />}
            <div className={classes.body}>
                {
                    props.children
                }
            </div>
            
        </div>
    )
}

AdminLayout.propTypes = {
    children: PropTypes.node.isRequired
};

export default AdminLayout;